module.exports = __webpack_public_path__ + "img/orderSuccess.ec573599.png";